import { getParamMeta } from '../constants/paramMeta'
import { ModelDetailSection } from './ModelDetailSection'
import { TagChip } from '@/features/models/components/ModelCardCells'

interface ModelDetailGenerationParamsProps {
  params: Array<string>
}

export function ModelDetailGenerationParams({ params }: ModelDetailGenerationParamsProps) {
  if (params.length === 0) return null

  return (
    <ModelDetailSection title="Supported parameters" note="modelSettings">
      <ul className="flex flex-wrap gap-1.5">
        {params.map((param) => {
          const { label, icon: Icon } = getParamMeta(param)
          return (
            <li key={param}>
              <TagChip icon={Icon}>
                {label}
                <span className="text-[var(--color-text-tertiary)]">{param}</span>
              </TagChip>
            </li>
          )
        })}
      </ul>
    </ModelDetailSection>
  )
}
